<template>
    <div class="max-w-full mx-auto lg:max-w-4xl lg:px-12 mb-8">
        <div class="md:flex">
            <div class="w-full md:w-1/2 p-4 h-auto flex items-center justify-center">
                <img src="@/assets/images/pages/vase/vase.jpg" alt="vase">
            </div>
            <div class="w-full md:w-1/2">
                <div class="p-4 text-center">
                    <h2 v-html="$t('FREDDIES_ADDONS_LIKE_A_VASE', {
                        'firstName': $t(`${firstName}`) })"/>
                    <p v-text="$t('FREDDIES_ADDONS_WE_HAVE_DESIGNED')"></p>
                    <p v-text="$t('FREDDIES_ADDONS_BEAUTIFUL')"></p>
                </div>
                <div class="border p-4">
                    <div class="w-full">
                        <div class="px-4 py-2 flex items-center">
                            <input type="checkbox"
                                   v-model="paidVase"
                                   class="mr-2 leading-tight">
                            <p @click="paidVase = !paidVase"
                               class="pl-2 cursor-pointer"
                               v-html="checkboxCopy"/>
                        </div>
                    </div>
                    <div class="text-center">
                        <button class="btn btn--primary text-xs"
                                @click="submit" v-html="$t('FREDDIES_ADDONS_NEXT')">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SECTION_FREDDIES_ADDONS } from '@/constants/Gifting';
import { capitalizeFirstLetter } from '@/helpers/StringHelpers';

export default {
    name: 'FreddiesAddons',
    methods: {
        /**
         * Submit the form.
         *
         * @returns {void}
         */
        submit() {
            this.$store.commit('gifting/setSectionComplete', SECTION_FREDDIES_ADDONS);
            this.$router.push({ name: 'account.gifting.delivery-day' });
        },
    },
    computed: {
        ...mapGetters({
            address: 'address/getSelectedGiftingAddress',
        }),
        firstName() {
            return capitalizeFirstLetter(this.address.first_name);
        },
        vasePrice() {
            let price = this.$store.getters['gifting/getPaidVasePrice'];

            return parseInt(price || 0);
        },
        checkboxCopy() {
            return this.$t('FREDDIES_ADDONS_CHECKBOX_COPY', { vasePrice: this.vasePrice });
        },
        paidVase: {
            get() {
                return this.$store.getters['gifting/isPaidVaseAttached'];
            },
            set(value) {
                this.$store.commit('gifting/setAddonVase', value);
            },
        },
    },
};
</script>
